import { Component } from "solid-js";

interface SoftwareIconProps {
  class?: string;
}

export const SoftwareIcon: Component<SoftwareIconProps> = (props) => {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <path
        d="M21.4133 26.3334H23.7467"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.8333 13.5C18.4519 13.5 17.3333 14.6187 17.3333 16"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.5001 9.33331C15.5547 9.33331 13.1667 11.7213 13.1667 14.6666"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M24.0001 13.3333H25.3334C26.8067 13.3333 28.0001 14.5266 28.0001 16V26.6666C28.0001 28.14 26.8067 29.3333 25.3334 29.3333H19.8334C18.3601 29.3333 17.1667 28.14 17.1667 26.6666V20"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.6 22.6667L12.08 26.8134"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.6667 26.8133H17.1667"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M25.3333 8V6.66667C25.3333 5.19333 24.14 4 22.6667 4H6.66667C5.19333 4 4 5.19333 4 6.66667V20C4 21.4733 5.19333 22.6667 6.66667 22.6667H17.1667"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
